<div class="reviews-table">
  <table>
    <thead>
      <tr>
        <td translate>reviews.table.thead.company-id.label</td>
        <td translate>reviews.table.thead.platform.label</td>
        <td translate>reviews.table.thead.timestamp.label</td>
        <td translate>reviews.table.thead.rating.label</td>
        <td translate>reviews.table.thead.notes.label</td>
        <td translate>reviews.table.thead.cons.label</td>
        <td translate>reviews.table.thead.pros.label</td>
        <td translate>reviews.table.thead.actions.label</td>
      </tr>
    </thead>
    <tbody *ngIf="!loading">
      <tr *ngFor="let review of reviews" class="reviews-data-row">
        <td class="reviews-data-row__id">
          <ng-container [ngSwitch]="review.company_status">
            <a *ngSwitchCase="reviewCompanyStatus.ACTIVE" routerLink="/dashboard/companies/{{review.company_id}}/reviews">{{review.company_id}}</a>
            <span *ngSwitchCase="reviewCompanyStatus.ARCHIVED" [ngbTooltip]="'reviews.table.company-tooltip' | translate">{{review.company_id}}</span>
          </ng-container>
        </td>
        <td class="reviews-data-row__platform">
          <a class="platform" [href]="review.url" target="_blank">
            <span
              [ngClass]="review.platform === 'TRUSTPILOT' ? 'vox-chip vox-chip_royal-blue' : 'vox-chip vox-chip_aquamarine'">{{review.platform}}</span>
            <i [ngbTooltip]="review.url" class="fa fa-link"></i>
          </a>
        </td>
        <td class="reviews-data-row__timestamp">
          <span>{{review.timestamp | date: 'd.M.y': undefined: locale}}<br> {{review.timestamp | date: 'h:mm a':
            undefined: locale}}</span>
        </td>
        <td class="reviews-data-row__rating">
          <div>
            <ngb-rating [rate]="review.rating ? review.rating : 0" [readonly]="true" [max]="5">
              <ng-template let-fill="fill" let-index="index">
                <i class="star-rating icon-small-star-outline" [class.icon-small-star]="fill === 100"></i>
              </ng-template>
            </ngb-rating>
          </div>
        </td>
        <td class="reviews-data-row__notes">
          <h4>{{review.title}}</h4>
          <p>
            {{review.notes}}
          </p>
        </td>
        <td class="reviews-data-row__cons">
          <p>
            {{review.cons}}
          </p>
        </td>
        <td class="reviews-data-row__pros">
          <p>
            {{review.pros}}
          </p>
        </td>
        <td class="reviews-data-row__actions">
          <div class="actions">
            <button [disabled]="review.company_status === reviewCompanyStatus.ARCHIVED" class="vox-btn btn btn-warning" (click)="openUpdateReviewPopup(review)">
              <i class="icon-small-edit"></i>
            </button>
            <button class="vox-btn btn btn-warning" (click)="openDetailsReviewPopup(review)">
              <i class="icon-small-info"></i>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
    <tbody *ngIf="loading">
      <tr *ngFor="let i of loadingLinesArray">
        <td colspan="10">
          <ngx-skeleton-loader></ngx-skeleton-loader>
        </td>
      </tr>
    </tbody>
    <tbody *ngIf="!loading && reviews.length === 0" class="reviews-table__empty">
      <tr>
        <td colspan="10" translate>reviews.empty</td>
      </tr>
    </tbody>
  </table>
</div>